enum NotifyErrorDescription {
  UnexpectedError = "An unexpected error occurred",
  UnexpectedErrorContactHelpCenter = "An unexpected error occurred. Please contact the help center if the problem persists",
  UnexpectedErrorPleaseRefresh = "An unexpected error occurred, please refresh and try again",
  UnexpectedErrorTryAgainLater = "An unexpected error occurred. Please try again later",
}

export default NotifyErrorDescription;
